<template>
  <gj-modal
      notFooterPadding
      size="1200_auto"
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      :no-padding="true"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>设为关键词</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          :inline="true">
        <gj-table
            ref="gjTable"
            errorColumn
            :index="false"
            name="adSetKeyword"
            :loading="loading"
            :adapt-height="false"
            :height="380"
            :data="form.items"
            :columns="columns">
          <template v-slot:matchType="{ index }">
            <el-form-item
                :prop="`items.${index}.matchType`"
                class="gj-table-item"
                :rules="[
                  { required: true, message: '请选择匹配类型', trigger: ['change'] }
                ]">
              <gj-select
                  v-model="form.items[index].matchType"
                  :options="options.matchType"
                  width="200px"
                  :clearable="false"
              ></gj-select>
            </el-form-item>
          </template>
          <template v-slot:campaign="{ index }">
            <el-form-item
                :prop="`items.${index}.campaignId`"
                class="gj-table-item"
                :rules="[
                  { required: true, message: '请选择广告活动', trigger: ['change'] }
                ]">
              <gj-select
                  v-model="form.items[index].campaignId"
                  width="200px"
                  :options="options.campaign"
                  :clearable="false"
              >
                <template v-slot:default="{ option }">
                  <span :class="`state state-${option.state}`"></span>
                  {{ option.campaignName }}
                </template>
              </gj-select>
            </el-form-item>
          </template>
          <template v-slot:bid="{ index }">
            <el-form-item
                :prop="`items.${index}.bid`"
                :rules="[
                  { required: true, message: '请输入竞价', trigger: ['change'] },
                  $gjReRule(RE.num(2), '请输入2位小数的正数'),
                  $gjMinRule(0.02, '应大于等于0.02')
                ]"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[index].bid"
                  width="200px">
                <template #prepend>{{adStore.SB.currencySymbol}}</template>
              </gj-input>
            </el-form-item>
          </template>
        </gj-table>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import { SB } from "@/api/ad";
  import { adStore } from "modules/ad/common/store";
  import { formRuleMixin, modalMixIn } from "@/minxins";

  export default {
    name: "app-set-keyword-modal",
    mixins: [modalMixIn, formRuleMixin],
    props: {
      marketId: {
        required: true
      },
      items: {
        required: true
      },
    },
    async created() {
      this.productInit()
    },
    data() {
      return {
        adStore,
        loading: false,
        form: {
          items: []
        },
        options: {
          campaign: [],
          matchType: [
            {id: 0, text: '精确匹配'},
            {id: 1, text: '词组匹配'},
            {id: 2, text: '广泛匹配'}
          ]
        },
        columns: [
          {id: 'keywordText', header: '用户搜索词', field: 'keywordText', width: '220px'},
          {id: 'matchType', header: '匹配类型', field: 'slot:matchType', minWidth: '220px', required: true},
          {id: 'campaign', header: '广告活动', field: 'slot:campaign', minWidth: '220px', required: true},
          {id: 'bid', header: '竞价', field: 'slot:bid', width: '220px', required: true},
        ],
      }
    },
    methods: {
      // 初始化form.items数据
      productInit() {
        this.loading = true;
        Promise.all([this.selectSbCampaigns()])
          .then(() => {
            this.form.items = this.items.map(e => ({
              keywordText: e.query,
              matchType:this.options.matchType.find(i => i.id == e.matchType) ? e.matchType : null,
              campaignId: e.campaignId,
              bid: null,
            }))
          })
          .complete(() => this.loading = false );
      },
      // 获取所有的广告活动组合
      async selectSbCampaigns() {
        const params = {
          marketId: this.marketId,
          states: [0, 1],
          targetingType: 0
        }
        const { data } = await SB.selectSbCampaigns(params)
        this.options.campaign = data.map(e => ({
          ...e,
          id: e.campaignId,
          text: e.campaignName
        }))
      },
      // 提交
      confirm() {
        this.$refs.form.validate(async (valid) => {
          if(!valid) return false;
           this.confirmLoading = true;
            const params = {
              marketId: this.marketId,
              keywords: this.form.items.map(item => ({
                campaignId: item.campaignId,
                keywordText: item.keywordText,
                matchType: item.matchType,
                bid: item.bid
              }))
            };
            try {
              let { msg } = await SB.saveKeywordsBySearchKeywords(params)
              this.$gjMessage.success(msg || '创建成功');
              this.$emit('created');
              this.$gjDestroy();
            } finally {
              this.confirmLoading = false;
            }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .state {
      width: 6px;
      height: 6px;
      background: #999;
      display: inline-block;
      border-radius: 50%;
      margin-right: 3px;
      cursor: pointer;
      &.state-0 {
          background-color: #1F6EEF;
      }
      &.state-1 {
          background-color: #ddd;
      }
  }
  /deep/ .vxe-table--border-line{
    border: 1px solid #d8dadd !important;
  }
</style>
